import { translate } from 'store/modules/base/i18n';
import { connect } from 'store/modules/base/redux';
import { MoreIcon } from 'assets/images';
import React from 'react';
import AbstractButton from './AbstractButton';
import withBoundary from 'component/ErrorBoundary/withBoundary';

/**
 * Implements an {@link AbstractButton} to open the user documentation in a new window.
 */
class MoreButton extends AbstractButton {
  accessibilityLabel = 'toolbar.accessibilityLabel.more';
  icon = MoreIcon;
  label = 'toolbar.more';
  type = 'purple';

  // tooltip = 'toolbar.more';

  /**
   * Handles clicking / pressing the button, and opens a new window with the user documentation.
   *
   * @private
   * @returns {void}
   */
  _handleClick() {
    this.props.onIconClick();
  }
}

/**
 * Maps part of the redux state to the component's props.
 *
 * @param {Object} state - The redux store/state.
 * @returns {Object}
 */
function _mapStateToProps(state) {
  return {
    visible: true,
    _userIdleMode: state['features/settings'].userIdleMode
  };
}

export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(MoreButton)))
);
